import React from 'react';
import {
  GroupEntity,
  RELATION_CHILD_OF,
  RELATION_PARENT_OF,
  stringifyEntityRef,
} from '@backstage/catalog-model';

import {
  EntityRefLinks,
  getEntityRelations,
  useEntity,
} from '@backstage/plugin-catalog-react';


import { Link } from '@backstage/core-components';

import {
  Box,
  Typography,
  Divider,
  CardContent,
  CardHeader,
} from '@material-ui/core';

import {
  makeStyles,
} from '@material-ui/core/styles';

import GroupIcon from '@material-ui/icons/Group';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import PermIdentityIcon from '@material-ui/icons/PermIdentity';
import EmailIcon from '@material-ui/icons/Email';

import Alert from '@material-ui/lab/Alert';
import { Card } from '@mui/material';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },

  content: {
    display: 'flex',
    alignItems: 'flex-start',
    paddingTop: theme.spacing(2),
  },
  header:{
    fontSize: '1.5rem',
    fontWeight: 600,
    marginLeft: theme.spacing(4),
  },

  avatar: {
    width: 64,
    height: 64,
    minWidth: 64,
    borderRadius: '50%',
    background: '#e05274',
    color: '#fff',
    fontWeight: 700,
    fontSize: 28,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: theme.spacing(4),
    marginLeft: theme.spacing(2),
  },

  details: {
    flex: 1,
  },

  row: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(3),
  },

  icon: {
    marginRight: theme.spacing(2),
    marginTop: 2,
    color: theme.palette.text.secondary,
  },

  value: {
    fontSize: '1rem',
  },

  label: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    marginTop: 2,
  },
}));

export const GroupProfileCard = () => {
  const classes = useStyles();


  const { entity: group } = useEntity<GroupEntity>();

  

  if (!group) {
    return <Alert severity="error">Group not found</Alert>;
  }

  const {
    metadata: {
      name,
      title,
    },
    spec: {
      profile,
    },
  } = group;

  const displayName =
    profile?.displayName ??
    title ??
    name;

  const parentRelations = getEntityRelations(
    group,
    RELATION_CHILD_OF,
    { kind: 'Group' },
  );

  const childRelations = getEntityRelations(
    group,
    RELATION_PARENT_OF,
    { kind: 'Group' },
  );

 
  const initials = displayName
    .split(' ')
    .map(x => x[0])
    .join('')
    .substring(0, 2)
    .toUpperCase();

  return (
    <Card>
    <CardHeader
  title={
    <Box display="flex" alignItems="center">
      <GroupIcon />
      <Typography
        variant="h5"
        style={{ marginLeft: 8, fontWeight: 600 }}
      >
        {displayName}
      </Typography>
    </Box>
  }
  subheader={`Entra ID: ${name}`.toUpperCase()}
/>
      <CardContent>
      <Divider />

      <Box className={classes.content}>
        <div className={classes.avatar}>
          {initials}
        </div>

        <div className={classes.details}>
          <div className={classes.row}>
            <PermIdentityIcon className={classes.icon} />

            <div>
              <Typography className={classes.value}>
                {stringifyEntityRef(group)}
              </Typography>

              <Typography className={classes.label}>
                Entity Ref
              </Typography>
            </div>
          </div>

          {profile?.email && (
            <div className={classes.row}>
              <EmailIcon className={classes.icon} />

              <div>
                <Typography className={classes.value}>
                  <Link to={`mailto:${profile.email}`}>
                    {profile.email}
                  </Link>
                </Typography>

                <Typography className={classes.label}>
                  Email
                </Typography>
              </div>
            </div>
          )}

          <div className={classes.row}>
            <AccountTreeIcon className={classes.icon} />

            <div>
              <Typography className={classes.value}>
                {parentRelations.length ? (
                  <EntityRefLinks
                    entityRefs={parentRelations}
                    defaultKind="Group"
                  />
                ) : (
                  'N/A'
                )}
              </Typography>

              <Typography className={classes.label}>
                Parent Group
              </Typography>
            </div>
          </div>

          <div className={classes.row}>
            <GroupIcon className={classes.icon} />

            <div>
              <Typography className={classes.value}>
                {childRelations.length ? (
                  <EntityRefLinks
                    entityRefs={childRelations}
                    defaultKind="Group"
                  />
                ) : (
                  'N/A'
                )}
              </Typography>

              <Typography className={classes.label}>
                Child Groups
              </Typography>
            </div>
          </div>
        </div>
      </Box>

      </CardContent>

    </Card>
  );
};